import classnames from 'classnames';
import { Label } from 'components/InputsMex/containers/components';
import React from 'react';
import { TARJETAS_PROPS } from 'utils/constants/TARJETAS';

const SeleccionarTarjeta = ({
  tarjetaSeleccionada: selected,
  setTarjetaSeleccionada: setter,
}) => {
  return (
    <div className="col-12 my-4">
      <Label style={{ fontSize: '20px' }}>Seleccionar tarjeta:</Label>
      <div className="d-flex flex-row flex-grow-0 mob-flex-style">
        <ButtonTarjeta
          setter={setter}
          value={selected}
          name="visa"
          label="VISA"
          style={{ zIndex: '99' }}
        />
        <ButtonTarjeta
          setter={setter}
          value={selected}
          name="mastercard"
          label="MASTER CARD"
          style={{ zIndex: '99' , minWidth: '156px'}}
        />
        <ButtonTarjeta
          setter={setter}
          value={selected}
          name="amex"
          label="AMEX"
          style={{ zIndex: '99' }}
        />
      </div>
    </div>
  );
};

export default SeleccionarTarjeta;

const ButtonTarjeta = ({ setter, value, name, label, style = {} }) => {
  return (
    <button
      type="button"
      className={classnames('btn', {
        'btn-outline-primary': value !== name,
        'btn-primary': value === name,
      })}
      style={{ minWidth: '150px', ...style }}
      onClick={() => {
        setter(TARJETAS_PROPS[name]);
      }}
    >
      {label}
    </button>
  );
};
